import { Container, styled } from "@mui/material";

const PageContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: "40px",
}));

export default PageContainer;
